import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Inventory} from '../inventory';
import {InventoryService} from '../inventory.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {EmployeesShowComponent} from "../../../setting/employees/employees-show/employees-show.component";
import {ItemService} from "../../../setting/items/items.service";
import {SupplierService} from "../../../setting/suppliers/supplier.service";
import {ItemsGroupService} from "../../../setting/itemsGroups/itemsGroups.service";
import {TaxService} from "../../../setting/taxes/tax.service";
import {formatDate} from "ngx-bootstrap/chronos";
import {forEach} from "@angular/router/src/utils/collection";
import {BranchService} from "../../../setting/branches/branch.service";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {SuppliersShowComponent} from '../../../setting/suppliers/suppliers-show/suppliers-show.component';
import {ItemsShowComponent} from '../../../setting/items/items-show/items-show.component';
import {BranchesShowComponent} from '../../../setting/branches/branches-show/branches-show.component';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        InventoryShowComponent
    ],
    entryComponents: [
        InventoryShowComponent
    ],
    exports: [],
    providers: [SharedService, InventoryService, MessageService, ConfirmationService, SupplierService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-inventory-show',
    templateUrl: './inventory-show.component.html',
    styleUrls: ['./inventory-show.component.scss'],
    providers: [InventoryService, ConfirmationService, MessageService, SupplierService]
})

export class InventoryShowComponent implements OnInit, AfterViewInit {
    id: string;
    picture: string;
    inventory = new Inventory();
    status: string;
    cnamelock = false;
    inventory_groups_id: string;
    statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
    form: FormGroup;
    public tax: number;
    private sub: any;
    branches: any[] = [];
    cities: any[] = [];
    bank: any[] = [];
    suppliers: any[] = [];
    allinvdetails: any[] = [];
    allinventoryd: any[] = [];
    today = formatDate(new Date(), "YYYY-MM-DD");
    public item_name: string;
    Selecteditem: any;
    Selecteditemcost: any = 0.0;
    Selecteditemquty: any = 0.0;
    Selecteditemtotal_b_tax: any;
    Selecteditemtotal_a_tax: any;
    Selecteditemtax: any;
    Selecteditemdetails: any;
    Selected_payment: any[] = [];
    itemCount: any[] = [];
    deletedrow: any[] = [];
    selectedrow: any[] = [];
    restoreInv: any;

    Selected_items: any[] = [];
    items: SelectItem[] = [];
    Selected_items_db: string[] = [];
    selectedItem: any[] = [];
    allitems: any = [];
    items_enhance: any = [];
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    webPattern = "^www+\.[a-z0-9.-]+\.[a-z]{2,4}$";
    emailErr: boolean = false;
    siteErr: boolean = false;
    public focusname = true;
    itemCountPayment: any[] = [];
    payment_list: any[] = [];

    allbranches: any[] = [];
    branches_enhance: any[] = [];

    @Input() refShow;
    // picture:string;x
    applog: AppLogComponent;
    parent_name: any;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent: any;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;

    defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
    DescVal = [{'val': 1, 'title': 'Percentage'}, {'val': 2, 'title': 'Cost'}];

    private item: any;
    mainitem: any = {value: "", inx: -1};

    // deletedrow: any[] = [];
    deletedrowPayment: any[] = [];


    invoice_arr: any[] = [];
    invoice_list_arr: any[] = [];
    inv_old_list_arr: any[] = [];
    invoice_payment_arr: any[] = [];
    public allpaid: any = 0.0;
    public allremain: any = 0.0;
    allquty: any = 0;
    allcost_b_tax: any = 0;
    allcost_a_tax: any = 0;
    alltaxes: any = 0;
    allAdisscount: any = 0;
    allAddtaxes: any = 0;
    allcostsforone: any = 0;
    alldiscountvalue: any = 0;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private inventoryService: InventoryService,
                private modalService: NgbModal,
                private itemservice: ItemService,
                private branchService: BranchService,
                private itemGroup: ItemsGroupService,
                private formBuilder: FormBuilder,
                private supplierService: SupplierService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs = [];

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(InventoryShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('inventory');

    }


    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.inventory;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        if (!this.scrId && !this.delId && !this.newData && !this.oldData) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/inventory/edit', this.id]);
                });
            }
            if (this._deleteButton) {

                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteInventory(this.inventory);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/inventory']);
                });

            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/inventory/search']);
                });

            }
        }
    }

  showParent() {
    console.log(this.parent);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        return true;
      }
    };
    this.modalRef = this.modalService.open(BranchesShowComponent, options);
    this.modalRef.componentInstance.scrId = this.parent;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }

  showItem(id){
    console.log(id);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(ItemsShowComponent, options);
    this.modalRef.componentInstance.scrId = id;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }

    ngOnInit() {
        this.msgs = [];

      this.branchService.getUserBranches().subscribe(
        allbranches => {
          this.branches = allbranches.brancheslist;

        });


      this.itemservice.getAllItems().subscribe(
        items => {
          this.allinvdetails = items.itemslist;
          this.items = items.itemslist;
        });

      this.sub = this.route.params.subscribe(params => {
        this.id = params['id'];
      });

      this.form = new FormGroup({
        id: new FormControl({value: '', disabled: true}),

        date: new FormControl({value: '', disabled: true}),
        time: new FormControl({value: '', disabled: true}),
        // storage_branch: new FormControl('', Validators.required),
        branch_id: new FormControl({value: '', disabled: true}),

      });

      if (this.id) {
        this.oldData = false;
        this.newData = false;
        this.delId = false;
        this.newDatap = true;
        this.inventoryService.getById(this.id).subscribe(
          inventory => {
            console.log(inventory);
            this.id = inventory.inventory.id;
            this.inventory = inventory.inventory;
            this.invoice_list_arr = inventory.itemsdetails;
            this.form.patchValue({
              id: inventory.inventory.id,
              date: inventory.inventory.date,
              time: inventory.inventory.time,
              branch_id: inventory.inventory.branch_id,
            });
            this.Selected_items = [];
            for(let i=0; i< this.invoice_list_arr.length; i++) {

              let iserte = {
                item_id: this.invoice_list_arr[i].item_id,
                statement:this.invoice_list_arr[i].statement ,
                system_quantity:this.invoice_list_arr[i].system_quantity ,
                inventory_quantity:this.invoice_list_arr[i].inventory_quantity
              };

              this.selectedItem.push(this.invoice_list_arr[i].item_id);

              this.Selected_items[i] = iserte;
            }

            this.itemCount = Array(this.Selected_items.length ).fill(2);

            // window.alert(this.allremain);
          }, error => {
            console.log(error);
          }
        );

      }

      if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

          this.inventoryService.getById(this.scrId).subscribe(
            inventory => {
              this.invoice_arr = inventory.inventory;
              this.invoice_list_arr = inventory.itemsdetails;
              this.selectedItem = inventory.selecteditems;
              this.id = inventory.inventory.id;
              this.inventory = inventory.inventory;
              // this.parent = inventory.main_bank;
              this.form.patchValue({
                id: inventory.inventory.id,
                date: inventory.inventory.date,
                time: inventory.inventory.time,
                branch_id: inventory.inventory.branch_id,
              });

              for(let i=0; i<this.invoice_list_arr.length; i++){
                let iserte = {
                  item_id: this.invoice_list_arr[i].item_id,
                  statement:this.invoice_list_arr[i].statement ,
                  system_quantity:this.invoice_list_arr[i].system_quantity ,
                  inventory_quantity:this.invoice_list_arr[i].inventory_quantity
                };
                this.Selected_items[i] = iserte;
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);



            }, error => {
              console.log(error);
            }
          );

        }

        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.inventoryService.getTrashedById(this.delId).subscribe(
                inventory => {
                    this.id = inventory.inventory.id;
                    this.inventory = inventory.inventory;
                  this.invoice_list_arr = inventory.itemsdetails;
                    this.form.patchValue({
                        id: inventory.inventory.id,
                      date: inventory.inventory.date,
                      time: inventory.inventory.time,
                      branch_id: inventory.inventory.branch_id,

                    });
                  this.Selected_items = [];
                  for(let i=0; i< this.invoice_list_arr.length; i++) {

                    let iserte = {
                      item_id: this.invoice_list_arr[i].item_id,
                      statement:this.invoice_list_arr[i].statement ,
                      system_quantity:this.invoice_list_arr[i].system_quantity ,
                      inventory_quantity:this.invoice_list_arr[i].inventory_quantity
                    };

                    this.selectedItem.push(this.invoice_list_arr[i].item_id);

                    this.Selected_items[i] = iserte;
                  }

                  this.itemCount = Array(this.Selected_items.length ).fill(2);
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
          console.log("show",this.oldData,this.newData);
            this.inventory = this.newData.inventory;
          this.invoice_list_arr = this.newData.itemsdetails;
          this.restoreInv = this.oldData.inventory;
          this.restoreInv.inv_details = JSON.stringify(this.oldData.itemsdetails);
          this.inv_old_list_arr = this.oldData.itemsdetails;
            this.form.patchValue({
              id: this.newData.inventory.id,
              date: this.newData.inventory.date,
              time: this.newData.inventory.time,
              branch_id: this.newData.inventory.branch_id,
            });

          this.Selected_items = [];
          for(let i=0; i< this.invoice_list_arr.length; i++) {

            let iserte = {
              item_id: this.invoice_list_arr[i].item_id,
              statement:this.invoice_list_arr[i].statement ,
              system_quantity:this.invoice_list_arr[i].system_quantity ,
              inventory_quantity:this.invoice_list_arr[i].inventory_quantity
            };

            this.selectedItem.push(this.invoice_list_arr[i].item_id);

            this.Selected_items[i] = iserte;
          }

          this.itemCount = Array(this.Selected_items.length ).fill(2);
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.inventory.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteInventory(inventory: Inventory) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (inventory) {
                    this.inventoryService.delete(inventory.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(() => {
                                this.router.navigate(['/inventory']);
                            }, 1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    changeallremain() {

        this.allremain = 0.0;
        this.allquty = 0.0;
        this.allcostsforone = 0.0;
        this.allcost_b_tax = 0.0;
        this.allcost_a_tax = 0.0;
        this.alltaxes = 0.0;

        for (let i = 0; i < this.Selected_items.length; i++) {
            // window.alert(this.allquty);

            this.allquty += parseFloat(this.Selected_items[i].qty);
            this.allcostsforone += parseFloat(this.Selected_items[i].cost);
            this.allcost_b_tax += parseFloat(this.Selected_items[i].totalBtax);
            this.allcost_a_tax += parseFloat(this.Selected_items[i].totalAtax);
            this.allAdisscount += parseFloat(this.Selected_items[i].costADiscount);
            this.allAddtaxes += parseFloat(this.Selected_items[i].addTax);

            this.alltaxes += parseFloat(this.Selected_items[i].taxvalue);
        }

        let discv = this.form.controls['disc_value'].value;
        let disct = this.form.controls['disc_type'].value;
        console.log(discv);
        if (disct == 1) {
            this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
        } else {
            this.alldiscountvalue = parseFloat(discv).toFixed(2);
        }

        this.allremain = (parseFloat(this.allcost_a_tax) - parseFloat(this.alldiscountvalue) - parseFloat(this.allpaid)).toFixed(2);
    }

    recoverEdit(inventory: Inventory) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (inventory) {
                    this.inventoryService.update(inventory).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/inventory/show', inventory.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.inventoryService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted inventory recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/inventory/list']);
                        }
                    );
                }
            }
        });
    }

    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.refShow = InventoryShowComponent;

            modalRef.componentInstance.rowId = row_id;
        }
    }

    changallpaid() {
        this.allpaid = 0.0;
        for (let i = 0; i < this.Selected_payment.length; i++) {
            console.log(this.Selected_payment[i].payment_amount);
            this.allpaid += parseFloat(this.Selected_payment[i].payment_amount);
        }
        let discv = this.form.controls['disc_value'].value;
        let disct = this.form.controls['disc_type'].value;
        console.log(discv);
        if (disct == 1) {
            this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
        } else {
            this.alldiscountvalue = parseFloat(discv).toFixed(2);
        }

        this.allremain = (parseFloat(this.allcost_a_tax) - parseFloat(this.alldiscountvalue) - parseFloat(this.allpaid)).toFixed(2);

    }

    changealldiscount() {
        let discv = this.form.controls['disc_value'].value;
        let disct = this.form.controls['disc_type'].value;

        console.log(disct);
        console.log(discv);
        if (disct == 1) {
            this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
        } else {
            this.alldiscountvalue = parseFloat(discv).toFixed(2);
        }
        console.log(this.alldiscountvalue);
        //this.changallpaid();
        this.changeallremain();


    }


}



// WEBPACK FOOTER //
// ./src/app/views/pro/inventory/inventory-show/inventory-show.component.ts